import { PATH } from 'common/constants';
import type { SurveyCountryFallback } from '../survey';
import { GenericNotification } from './GenericNotification';

const MAX_COUNTRIES = 5;
const MAX_GROUPS = 3;

// "India, Indonesia, Philippines +2 more"
function listWithMore(items: string[], max: number): string {
  const shown = items.slice(0, max).join(', ');
  return items.length > max ? `${shown} +${items.length - max} more` : shown;
}

type Props = { surveyName: string; fallback: SurveyCountryFallback };

export function CountryFallbackNotification({ surveyName, fallback }: Props) {
  const countryCount = fallback.countries.length;
  const groups = listWithMore(fallback.groups, MAX_GROUPS);
  const countries = listWithMore(fallback.countries, MAX_COUNTRIES);
  return (
    <GenericNotification
      title={`Survey available: fallback used for ${countryCount} ${countryCount === 1 ? 'country' : 'countries'}`}
      description={`${surveyName}. In ${fallback.mapping_profile_name}, ${groups} used the default mapping for ${countries}: the country-specific columns aren't in this file.`}
      link={{ text: 'Review mapping', link: PATH.FIELD_MAPPING_CONFIGURATION_VIEWER(fallback.mapping_profile_id) }}
      tag={{ color: 'warning', children: 'Check mapping' }}
    />
  );
}
